interface Props {
  children: React.ReactNode;
}

export const Graphs: React.FC<Props> = ({ children }) => {
  return (
    <div className="col-span-3 shadow-md bg-white p-5 lg:space-y-5 md:space-y-4 space-y-0.5 rounded-lg text-gray-600">
      {children}
    </div>
  );
};
